import {useMutation, UseMutationResult} from '@tanstack/react-query'
import {fetchResponse} from './utils'

interface Args {
  trackingNumber: string
}

interface TrackingResponse {
  trackingUrl: string
}

export const useShipmentTracking = (): UseMutationResult<TrackingResponse, Error, Args> => {
  return useMutation({
    mutationFn: async ({trackingNumber}: Args): Promise<TrackingResponse> => {
      const data = (await fetchResponse(
        `/v1/shipment-tracking/${trackingNumber}`,
      )) as TrackingResponse
      return data
    },
    onSuccess: (data) => {
      if (data.trackingUrl) {
        window.open(data.trackingUrl, '_blank')
      }
    },
  })
}
